module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("His Love Endures Forever: A Land of Canaan Novel")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('meta', {
    attrs: {
      "charset": "utf-8"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ct",
    attrs: {
      "id": "p0009-02-0"
    }
  }, [_c('a', {
    attrs: {
      "id": "pageix"
    }
  }, [_c('span', [_c('i', [_c('img', {
    attrs: {
      "alt": "9781595548887_INT_0009_001.jpg",
      "id": "p0009-d6e5",
      "src": "images/9781595548887_INT_0009_001.jpg"
    }
  })])])]), _c('i', [_c('a', {
    attrs: {
      "href": "#/chapter1d#d6e2"
    }
  }, [_vm._v("  Pennsylvania Dutch Glossary")])])]), _vm._v(" "), _c('p', {
    staticClass: "txy2",
    attrs: {
      "id": "p0009-03-1"
    }
  }, [_c('span', [_c('i', [_vm._v("ab im kopp")]), _vm._v("—crazy or off in the head")])]), _vm._v(" "), _c('p', {
    staticClass: "txy2",
    attrs: {
      "id": "p0009-04-2"
    }
  }, [_c('span', [_c('i', [_vm._v("ach")]), _vm._v("—oh")])]), _vm._v(" "), _c('p', {
    staticClass: "txy2",
    attrs: {
      "id": "p0009-05-3"
    }
  }, [_c('span', [_c('i', [_vm._v("aentis")]), _vm._v("—aunts")])]), _vm._v(" "), _c('p', {
    staticClass: "txy2",
    attrs: {
      "id": "p0009-06-4"
    }
  }, [_c('span', [_c('i', [_vm._v("baremlich")]), _vm._v("—terrible")])]), _vm._v(" "), _c('p', {
    staticClass: "txy2",
    attrs: {
      "id": "p0009-07-5"
    }
  }, [_c('span', [_c('i', [_vm._v("boppli")]), _vm._v("—baby")])]), _vm._v(" "), _c('p', {
    staticClass: "txy2",
    attrs: {
      "id": "p0009-08-6"
    }
  }, [_c('span', [_c('i', [_vm._v("bruder")]), _vm._v("—brother")])]), _vm._v(" "), _c('p', {
    staticClass: "txy2",
    attrs: {
      "id": "p0009-09-7"
    }
  }, [_c('span', [_c('i', [_vm._v("danki")]), _vm._v("—thank you")])]), _vm._v(" "), _c('p', {
    staticClass: "txy2",
    attrs: {
      "id": "p0009-10-8"
    }
  }, [_c('span', [_c('i', [_vm._v("daed")]), _vm._v("—dad")])]), _vm._v(" "), _c('p', {
    staticClass: "txy2",
    attrs: {
      "id": "p0009-11-9"
    }
  }, [_c('span', [_c('i', [_vm._v("dochder")]), _vm._v("—daughter")])]), _vm._v(" "), _c('p', {
    staticClass: "txy2",
    attrs: {
      "id": "p0009-12-10"
    }
  }, [_c('span', [_c('i', [_vm._v("dummkopp")]), _vm._v("—dunce")])]), _vm._v(" "), _c('p', {
    staticClass: "txy2",
    attrs: {
      "id": "p0009-13-11"
    }
  }, [_c('span', [_c('i', [_vm._v("dumm")]), _vm._v("—dumb")])]), _vm._v(" "), _c('p', {
    staticClass: "txy2",
    attrs: {
      "id": "p0009-14-12"
    }
  }, [_c('span', [_c('i', [_vm._v("Englisch")]), _vm._v("—non-Amish")])]), _vm._v(" "), _c('p', {
    staticClass: "txy2",
    attrs: {
      "id": "p0009-15-13"
    }
  }, [_c('span', [_c('i', [_vm._v("Englischers")]), _vm._v("—non-Amish people")])]), _vm._v(" "), _c('p', {
    staticClass: "txy2",
    attrs: {
      "id": "p0009-16-14"
    }
  }, [_c('span', [_c('i', [_vm._v("es dutt mir leed—")]), _vm._v("I am sorry")])]), _vm._v(" "), _c('p', {
    staticClass: "txy2",
    attrs: {
      "id": "p0009-17-15"
    }
  }, [_c('span', [_c('i', [_vm._v("fraa")]), _vm._v("—wife")])]), _vm._v(" "), _c('p', {
    staticClass: "txy2",
    attrs: {
      "id": "p0009-18-16"
    }
  }, [_c('span', [_c('i', [_vm._v("guder mariye")]), _vm._v("—good morning")])]), _vm._v(" "), _c('p', {
    staticClass: "txy2",
    attrs: {
      "id": "p0009-19-17"
    }
  }, [_c('span', [_c('i', [_vm._v("gut")]), _vm._v("—good")])]), _vm._v(" "), _c('p', {
    staticClass: "txy2",
    attrs: {
      "id": "p0009-20-18"
    }
  }, [_c('span', [_c('i', [_vm._v("hatt")]), _vm._v("—hard")])]), _vm._v(" "), _c('p', {
    staticClass: "txy2",
    attrs: {
      "id": "p0009-21-19"
    }
  }, [_c('span', [_c('i', [_vm._v("haus")]), _vm._v("—house")])]), _vm._v(" "), _c('p', {
    staticClass: "txy2"
  }, [_c('span', [_c('i', [_vm._v("kaffi")]), _vm._v("—coffee")])]), _vm._v(" "), _c('p', {
    staticClass: "txy2",
    attrs: {
      "id": "p0010-02-1"
    }
  }, [_c('span', [_c('i', [_vm._v("kapp")]), _vm._v("—prayer covering or cap")])]), _vm._v(" "), _c('p', {
    staticClass: "txy2",
    attrs: {
      "id": "p0010-03-2"
    }
  }, [_c('span', [_c('i', [_vm._v("kinner")]), _vm._v("—children or grandchildren")])]), _vm._v(" "), _c('p', {
    staticClass: "txy2",
    attrs: {
      "id": "p0010-04-3"
    }
  }, [_c('span', [_c('i', [_vm._v("kumm")]), _vm._v("—come")])]), _vm._v(" "), _c('p', {
    staticClass: "txy2",
    attrs: {
      "id": "p0010-05-4"
    }
  }, [_c('span', [_c('i', [_vm._v("lieb")]), _vm._v("—love")])]), _vm._v(" "), _c('p', {
    staticClass: "txy2",
    attrs: {
      "id": "p0010-06-5"
    }
  }, [_c('span', [_c('i', [_vm._v("maedel")]), _vm._v("—girl")])]), _vm._v(" "), _c('p', {
    staticClass: "txy2",
    attrs: {
      "id": "p0010-07-6"
    }
  }, [_c('span', [_c('i', [_vm._v("mamm")]), _vm._v("—mom")])]), _vm._v(" "), _c('p', {
    staticClass: "txy2",
    attrs: {
      "id": "p0010-08-7"
    }
  }, [_c('span', [_c('i', [_vm._v("mammi")]), _vm._v("—grandmother")])]), _vm._v(" "), _c('p', {
    staticClass: "txy2",
    attrs: {
      "id": "p0010-09-8"
    }
  }, [_c('span', [_c('i', [_vm._v("mei")]), _vm._v("—my")])]), _vm._v(" "), _c('p', {
    staticClass: "txy2",
    attrs: {
      "id": "p0010-10-9"
    }
  }, [_c('span', [_c('i', [_vm._v("mudder")]), _vm._v("—mother")])]), _vm._v(" "), _c('p', {
    staticClass: "txy2",
    attrs: {
      "id": "p0010-11-10"
    }
  }, [_c('span', [_c('i', [_vm._v("narrisch")]), _vm._v("—crazy")])]), _vm._v(" "), _c('p', {
    staticClass: "txy2",
    attrs: {
      "id": "p0010-12-11"
    }
  }, [_c('span', [_c('i', [_vm._v("nee")]), _vm._v("—no")])]), _vm._v(" "), _c('p', {
    staticClass: "txy2",
    attrs: {
      "id": "p0010-13-12"
    }
  }, [_c('span', [_c('i', [_vm._v("onkel")]), _vm._v("—uncle")])]), _vm._v(" "), _c('p', {
    staticClass: "txy2",
    attrs: {
      "id": "p0010-14-13"
    }
  }, [_c('span', [_c('i', [_vm._v("Ordnung")]), _vm._v("—the written and unwritten rules of the Amish; the understood behavior by which the Amish are expected to live, passed down from generation to generation. Most Amish know the rules by heart.")])]), _vm._v(" "), _c('p', {
    staticClass: "txy2",
    attrs: {
      "id": "p0010-15-15"
    }
  }, [_c('span', [_c('i', [_vm._v("Pennsylvania Deitsch")]), _vm._v("—Pennsylvania German, the language most commonly used by the Amish")])]), _vm._v(" "), _c('p', {
    staticClass: "txy2",
    attrs: {
      "id": "p0010-16-16"
    }
  }, [_c('span', [_c('i', [_vm._v("rumschpringe")]), _vm._v("—running-around period when a teenager turns sixteen years old")])]), _vm._v(" "), _c('p', {
    staticClass: "txy2",
    attrs: {
      "id": "p0010-17-17"
    }
  }, [_c('span', [_c('i', [_vm._v("schee")]), _vm._v("—pretty")])]), _vm._v(" "), _c('p', {
    staticClass: "txy2",
    attrs: {
      "id": "p0010-18-18"
    }
  }, [_c('span', [_c('i', [_vm._v("sohn")]), _vm._v("—son")])]), _vm._v(" "), _c('p', {
    staticClass: "txy2",
    attrs: {
      "id": "p0010-19-19"
    }
  }, [_c('span', [_c('i', [_vm._v("wedder")]), _vm._v("—weather")])]), _vm._v(" "), _c('p', {
    staticClass: "txy2",
    attrs: {
      "id": "p0010-20-20"
    }
  }, [_c('span', [_c('i', [_vm._v("wie bischt?")]), _vm._v("—how are you?")])]), _vm._v(" "), _c('p', {
    staticClass: "txy2",
    attrs: {
      "id": "p0010-21-22"
    }
  }, [_c('span', [_c('i', [_vm._v("ya")]), _vm._v("—yes")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cbff5012","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter2.vue
// module id = 78
// module chunks = 0